module.exports = __webpack_public_path__ + "static/data-distribution-6b823e5a58a46b40641111bab34fc4a4.svg";